const FORMAT_LABEL: Record<string, string> = {
  'image/jpeg': 'JPEG',
  'image/png': 'PNG',
  'image/webp': 'WebP',
};

export function uploadConversionNotice(
  original: Pick<File, 'name' | 'type'>,
  saved: Pick<File, 'name' | 'type'>,
): string | null {
  if (original.name === saved.name && original.type === saved.type) return null;
  const format = FORMAT_LABEL[saved.type] ?? saved.type;
  return `${original.name} was saved as ${saved.name} (${format}) so it can be posted to Instagram.`;
}

const SHORT_FORMAT_LABEL: Record<string, string> = {
  'image/jpeg': 'JPG',
  'image/jpg': 'JPG',
  'image/png': 'PNG',
  'image/webp': 'WebP',
  'image/heic': 'HEIC',
  'image/heif': 'HEIC',
};

export interface UploadConversion {
  from: string;
  to: string;
}

function shortFormat({ name, type }: Pick<File, 'name' | 'type'>): string {
  const known = SHORT_FORMAT_LABEL[type.toLowerCase()];
  if (known) return known;
  if (/\.hei[cf]$/i.test(name)) return 'HEIC';
  return type.split('/')[1]?.toUpperCase() || 'file';
}

export function uploadConversion(
  original: Pick<File, 'name' | 'type'>,
  saved: Pick<File, 'name' | 'type'>,
): UploadConversion | null {
  if (original.name === saved.name && original.type === saved.type) return null;
  return { from: shortFormat(original), to: shortFormat(saved) };
}
